import React from 'react';
import { Badge } from '@/components/ui/badge';

interface SLABadgeProps {
  agentName?: string;
  queueName?: string;
  slaCallCount: number;
  totalSLACalls: number;
}

export const SLABadge: React.FC<SLABadgeProps> = ({
  agentName,
  queueName,
  slaCallCount,
  totalSLACalls
}) => {
  return (
    <div className="flex items-center gap-2">
      {(agentName || queueName) && (
        <Badge variant="outline" className="ml-2 font-normal text-xs text-inherit">
          {agentName} - {queueName}
        </Badge>
      )}
      <Badge variant="outline" className="font-normal text-xs text-inherit">
        {slaCallCount}/{totalSLACalls} total calls
      </Badge>
    </div>
  );
};

